module.exports = __webpack_public_path__ + "img/08.f3ea9d8e.png";